import React from 'react';

const ICON = { owner: '🚗', admin: '🛡️', dispatcher: '🤖', fleet: '🏢', broker: '🤝', member: '👪' };

// One email, more than one account (a TagAlong car AND a dispatcher login, a broker…): a tab per service,
// like the admin sign-in's tabs. The one opened last time is marked; tapping a tab opens that service.
export default function ServiceTabs({ accounts = [], last = '', onPick, es = false, dark = false }) {
  const label = (a) => (es ? { owner: 'App TagAlong', admin: 'Dynamic Dispatch (admin)', dispatcher: 'Consola de despacho', fleet: 'TagAlong Flota', broker: 'Portal de corredores', member: 'Familia' }[a.kind] : a.label) || a.kind;
  return (
    <div data-testid="service-tabs" style={{ marginTop: 4 }}>
      <div style={{ fontSize: 14, fontWeight: 800, color: dark ? '#fff' : '#0f172a', marginBottom: 10 }}>{es ? 'Tienes más de una cuenta. ¿A dónde quieres entrar?' : 'You have more than one account. Where do you want to go?'}</div>
      <div role="tablist" aria-label="Open" style={{ display: 'flex', flexDirection: 'column', gap: 8, background: '#f1f5f9', borderRadius: 12, padding: 6 }}>
        {accounts.map((a) => (
          <button key={a.kind} type="button" role="tab" aria-selected={a.kind === last} onClick={() => onPick(a)}
            style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', border: 'none', borderRadius: 9, padding: '12px 14px', fontSize: 15, fontWeight: 800, cursor: 'pointer', textAlign: 'left', background: '#fff', color: '#0f172a', boxShadow: a.kind === last ? '0 0 0 2px #0066ff' : '0 1px 3px rgba(0,0,0,0.12)' }}>
            <span aria-hidden="true">{ICON[a.kind] || '•'}</span>
            <span style={{ flex: 1 }}>{label(a)}</span>
            {a.kind === last && <span style={{ fontSize: 11, color: '#0066ff' }}>{es ? 'última vez' : 'last time'}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
